import type { EventLogEntry } from "../types.js";
import { initNavigationSession } from "./navigation.js";
import { initCtSession } from "./ctSession.js";

export type Persistence = 'navigation' | 'ct-session';

export interface SessionHandle {
  sessionStartMs: number;
  loadEvents(): EventLogEntry[];
  save(buffer: EventLogEntry[]): void;
  destroy(): void;
}

export function initSession(persistence: Persistence = 'navigation'): SessionHandle {
  if (persistence === 'ct-session') return initCtSession();
  return initNavigationSession();
}
